import { StaticCard, StaticCardProps } from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { FCWC } from "shared/utils/FCWC";
import { Semantics } from "shared/utils/semantics";

type SemanticStaticCardProps = {
  semantics: Semantics;
};

export const SemanticStaticCard: FCWC<
  SemanticStaticCardProps & StaticCardProps
> = ({ semantics, children, ...rest }) => {
  const theme = useThemeSemantic(semantics);
  return (
    <StaticCard
      transition="all 0.2s ease-in-out"
      backgroundColor={theme.colorSemanticFill}
      _hover={{ backgroundColor: theme.colorSemanticFillPulse }}
      border="1px solid"
      borderColor="outline.disabled"
      {...rest}
    >
      {children}
    </StaticCard>
  );
};
